import { useCallback, useState } from 'react';

const useAuthStateHelpers = (instanceDoc) => {
  const [isDirty, setIsDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState(() => instanceDoc.data || {});

  const handleInput = useCallback(({ target: { name, value } }) => {
    setIsDirty(true);
    setData((c) => ({ ...c, [name]: value }));
  }, []);

  const handleCheckbox = useCallback(({ target: { name, checked } }) => {
    setIsDirty(true);
    setData((c) => ({ ...c, [name]: checked }));
  }, []);

  const handleNotification = useCallback(({ target: { name, checked } }) => {
    setIsDirty(true);
    setData((c) => ({
      ...c,
      noticePreferences: { ...c.noticePreferences, [name]: checked },
    }));
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e?.preventDefault();
      setIsLoading(true);
      instanceDoc
        .update(data)
        .then(() => {
          setIsDirty(false);
          setIsLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setIsLoading(false);
        });
    },
    [data, instanceDoc]
  );

  return {
    handleInput,
    handleCheckbox,
    handleNotification,
    handleSubmit,
    data,
    isDirty,
    isLoading,
    error,
  };
};

export default useAuthStateHelpers;
